import { KPI_VALUE_TIME } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const reelsAvgTimeWatchedConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.instagram.reels.reels_avg_time_watched',
    id: 'reel_average_time_watched',
    icon: {
        name: 'reel-plays',
        style: colors.pink
    },
    tooltip: 'analytics:kpi.instagram.reels.tooltip_reels_avg_time_watched',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    orientation: ORIENTATION_VERTICAL,
    data_format: KPI_VALUE_TIME,
    size: SIZE_25,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
